import React from 'react'

import { classNames } from '@lib/simpleFn'

type EachScoreBoxProps = {
  title: string
  score: string
  scoreTextColorClass?: string
}

const EachScoreBox: React.FC<EachScoreBoxProps> = ({ title, score, scoreTextColorClass }) => {
  return (
    <div className={'flex-1 text-center py-4'}>
      <div className={'text-base sm:text-lg'}>{title}</div>
      <div className={classNames('text-xl sm:text-2xl font-bold mt-2', scoreTextColorClass || '')}>
        {score}
      </div>
    </div>
  )
}

export default EachScoreBox
